"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixEnglishNumbers = exports.fixArabicNumbers = void 0;
var const_1 = require("../const");
var charLevelReplace_1 = require("./charLevelReplace");
function fixArabicNumbers(text) {
    return (
    // replaces arabic numbers with their persian equivalent
    charLevelReplace_1.charLevelReplace(text, const_1.arabicDigits, const_1.persianDigits));
}
exports.fixArabicNumbers = fixArabicNumbers;
function fixEnglishNumbers(text) {
    return (
    // replaces english numbers with their persian equivalent
    charLevelReplace_1.charLevelReplace(text, const_1.englishDigits, const_1.persianDigits));
}
exports.fixEnglishNumbers = fixEnglishNumbers;
